import { render, staticRenderFns } from "./ResultsDetailed.vue?vue&type=template&id=5da52b64&"
import script from "./ResultsDetailed.vue?vue&type=script&lang=js&"
export * from "./ResultsDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports